module.exports = __webpack_public_path__ + "static/img/item_back_bg_purple.8053dd77.svg";